import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12d4a639&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=12d4a639&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d4a639",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d4a639')) {
      api.createRecord('12d4a639', component.options)
    } else {
      api.reload('12d4a639', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12d4a639&scoped=true", function () {
      api.rerender('12d4a639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadExcel/index.vue"
export default component.exports